import React from "react";
import { useHistory } from "react-router-dom";
import { Button, Modal, ModalBody } from "reactstrap";
import { OroLoaderInline } from "../../core";

export default function SelectPaymentMode(props) {
  const {
    openPaymentMode,
    togglePaymentMode,
    paymentMethod,
    onPaymentChange,
    userAmount
  } = props;


  return (
    <Modal isOpen={openPaymentMode}
      centered>

      <ModalBody>
        {userAmount ?
          <>
            <div className="d-flex flex-row align-items-center justify-content-between px-5 pt-4 pb-3">
              <img style={{height: "3rem"}} src={process.env.REACT_APP_IMAGES_PATH + "biddeasy.webp"} alt="biddeasy-logo" /> 
            </div>
            <div className="p-4">
              <p className="font-size-18 font-weight-semi-bold text-center">
                Select Payment Mode
              </p>
              <div className="d-flex flex-column">
                <div className="d-flex flex-column payment-item">
                  {userAmount < 100000 &&
                    <div className="payment-type py-3 px-5 my-1">
                      <div class="custom-control custom-radio custom-control-inline ">
                        <input
                          type="radio"
                          id="upi"
                          name="paymentMethod"
                          class="custom-control-input"
                          checked={paymentMethod === "upi"}
                          onChange={() => onPaymentChange("upi")}
                        />
                        <label class="custom-control-label" for="upi">
                          UPI
                        </label>
                      </div>
                    </div>
                  }
                  <div className="payment-type py-3 px-5 my-1">
                    <div class="custom-control custom-radio custom-control-inline ">
                      <input
                        type="radio"
                        id="netbanking"
                        name="paymentMethod"
                        class="custom-control-input"
                        checked={paymentMethod === "netbanking"}
                        onChange={() => onPaymentChange("netbanking")}
                      />
                      <label class="custom-control-label" for="netbanking">
                        Net Banking
                      </label>
                    </div>
                  </div>
                  <div className="payment-type py-3 px-5 my-1">
                    <div class="custom-control custom-radio custom-control-inline ">
                      <input
                        type="radio"
                        id="neft"
                        name="paymentMethod"
                        class="custom-control-input"
                        checked={paymentMethod === "neft"}
                        onChange={() => onPaymentChange("neft")}
                      />
                      <label class="custom-control-label" for="neft">
                        NEFT/RTGS
                      </label>
                    </div>
                  </div>
                  <div style={{
                    padding: '20px 20px 0',
                    borderRadius: '5px',
                    border: '1px $secondary solid'
                  }}>
                    <p className="font-size-12">
                    Net Banking facility of Citibank is currently not available. 
                    We are working with our partner bank to enable it soon. If you wish to pay through the above bank, 
                    please select NEFT/RTGS mode to make the payment.
                    </p>
                 
                  </div>
                </div>
                <Button
                  color="secondary"
                  className="font-weight-semi-bold font-size-16 mt-3 ml-auto mr-auto w-50"
                  style={{ borderRadius: '10px' }}
                  onClick={togglePaymentMode}>
                  Pay
                </Button>
              </div>
            </div>
          </> : (
            <div className="mt-4">
              <OroLoaderInline />
            </div>
          )}
      </ModalBody>
    </Modal>
  );
}
